export default {
  Home: '首页',
  login: '登录',
  Dashboard: '看板',
  /// /完工管理系统
  // router
  Import: '导入/导出',
  Imports: '导入/导出',
  Import_Logs: '操作日志',
  RefTable: 'Ref表',
  Activity: '活动',
  Area: '区域',
  AuthorisedPerson: '授权人员',
  Disciplines: '专业',
  System: '系统',
  SystemDescription: '系统描述',
  SubSystem: '子系统',
  SystemGroup: '系统组',
  Profession: '岗位',
  ITRs: '检查测试表',
  MOCs: '变更',
  Document: '文档管理',
  menumanagement: '菜单管理',
  Accountlist: '用户列表',
  // 发行一版之后添加的
  Drawing: '图纸',
  DrawingType: '图纸类型',
  DrawingStatus: '图纸状态',
  TagITRs: '已编号检查测试表',
  Certification: '证书',
  EquipmentType: '设备类型',
  EquipmentStatus: '设备状态',
  EquipmentTypeITR: '设备类型对应的ITR',
  EquipmentTypePWL: '设备类型与维保项参照表',
  TagITRCompletionStatus: '检查测试表完成状态',
  Handover: '证书',
  CCC: '试运完工证书',
  MCC: '机械完工证书',
  PAC: '临时验收证书',
  RFSU: '启动证书',
  FAC: '最终验收移交证书',
  Phase: '阶段',
  Cable: '电缆',
  CableType: '电缆类型',
  DigitalDocumentCheckBoxType: '数字文档复选框类型',
  WorkPack: '工作包',
  JobCard: '工作卡',
  Operation: '操作',
  WorkPackGrid: '工作包网格',
  WorkPackSkyline: '工作包天际线',
  JobCardSkyline: '工作卡天际线',
  JobCardPlannedvsActualProgress: '工作卡计划进度与实际进度',
  ExCertifyingbody: '防爆证书颁发机构',
  ExIPRating: '防爆IP等级',
  ExProtection: '防爆保护类型',
  ExRatedModels: '防爆定额',
  ExRatedtoITR: '防爆等级与检查测试表参照表',
  ExZones: '防爆区',
  GlandTypes: '电缆格兰类型',
  HandoverCompletionStatus: '移交完成状态',
  JobCardStatus: '工作卡状态',
  Location: '位置',
  Loop: '回路',

  MOCStatus: '变更状态',
  MOCType: '变更类型',
  Module: '模块',
  NotificationGroup: '通知组',
  NotificationGroupAuthorisedPerson: '通知组授权人',
  OperationType: '作业类型',
  ParentTag: '母编号',
  PreservationCompletionStatus: '保养完成状态',
  ProcedureCategory: '程序类别',
  ProcedureClass: '程序文件等级',
  ProcedureCompletionStatus: '程序完成状态',
  ProcedureDocumentStatus: '程序文件状态',
  PunchListItemCategory: '尾项分类',
  PWL: '维护保养表',
  ServiceDetail: '保养内容',
  ServiceInterval: '保养间隔',
  Skill: '技能',
  SubcontractorName: '分包商名称',
  TestPackType: '测试包类型',
  UnitsofMeasure: '测量单位',
  Vendor: '供应商/厂家',
  WorkGroup: '工作组',
  WorkPackCompletionStatus: '工作包完成状态',
  WorkPackType: '工作包类型',
  TaggedItems: '编号资产',
  All: '全部',
  Line: '管线',
  MechanicalJoint: '机械连接头',
  Spool: '管段',
  Tag: '其他设备',
  TestPack: '测试包',
  TagSet: '设备包',
  MultiTagITR: '多标签ITR',
  EquipmentTypetoITRReview: '设备类型与检查测试表参照表',
  TagReviewforExAllocation: '防爆分配标签审查',
  CompletionsGrid: '完工网格',
  PunchList: '尾项清单',
  PunchListItem: '尾项',
  Procedure: '程序',
  ProcedureSection: '程序分段',
  ProcedureStep: '程序步骤',
  ProcedureSkeleton: '程序框架',
  ProcedureSkeletonSection: '程序框架分段',
  ProcedureSkeletonStep: '程序框架分步',
  Preservation: '维护保养',
  TagPWL: '维护保养清单',
  LookAhead: '维护保养计划',
  EquipmentTypetoPWLReview: '设备类型与维护保养参照表',
  AsBuiltDrawing: '竣工图纸',
  Attachment: '附件',
  ProcedureType: '程序文件类型',

  // page
  SEARCH: '快速搜索',
  Recent: '最近的搜索',
  SavedSearches: '保存的搜索',
  PRECISIONSEARCH: '精准搜索',
  ADVANCEDSEARCH: '高级搜索',
  ADDButton: '新增',
  DeleteButton: '删除',
  ExportButton: '导出',
  Name: '名称',
  Description: '描述',

  AddEditTitle: '新增',
  EditTitle: '编辑',
  Search: '搜索',
  SaveSearch: '保存搜索',
  Clear: '清除',
  Discipline: '专业',
  ITRClass: '检查测试表类别',
  ITRClassDescription: '检查测试表类别描述',
  Manhours: '工时',
  GenerationMethod: '生成方法',
  DigitalDocument: '数字文档',
  DOTXTemplate: 'DOTX模板',
  Revision: '修订',
  IsMultiTag: '是多标签',
  IsMockITR: '是模拟ITR',
  WitnessPoints: '见证点',
  HoldPoints: '持有点',
  CreatedDate: '创建日期',
  UpdatedDate: '更新日期',
  ChangeHistory: '变更历史',
  ShowDates: '显示日期',

  Company: '公司',
  Comments: '评论',

  HandoverGate: '移交',

  ProfessionDiscipline: '岗位专业',

  // 发行一版之后添加的

  RevisionDate: '修订时间',
  Region: '区域',
  Moudle: '模块',

  Sheet: '扩展',
  Originator: '发起人',
  DrawingTypeDescription: '图纸类型描述',
  Link: '链接',
  Subsystem: '子系统',

  Priority: '优先级',
  Attachments: '附件',
  TestReference: '测试参考',
  ITRDiscipline: 'ITR 专业',
  IsDefault: '是默认值',
  RequiresReason: '需要理由',
  DefaultFrequency: '默认频率',
  PWLDiscipline: '保养清单专业',
  Changes: '变更',
  Download: '下载',
  Report: '报告',
  ReportList: '报告列表',
  PlannedVsActualProgress: '计划进度与实际进度',
  Skyline: '天际线',
  ScheduledReport: '计划报告',
  Admin: '管理',
  SystemSettings: '系统管理',
  User: '用户管理',
  Menu: '菜单管理',
  Role: '角色管理',
  Department: '部门管理',
  PostManagement: '岗位管理',
  LevelSelect: '层级选择',
  LevelA: 'A级',
  LevelB: 'B级',
  LevelC: 'C级',
  LevelD: 'D级',
  LevelE: 'E级',

  // 按钮
  AddTitle: '新增',
  History: '历史',
  Save: '保存',
  View: '查看',
  Submit: '提交',
  SaveView: '保存&查看',

  // 9-9 li 新增
  RaisedBy: '提出人',
  RaisedDate: '提出日期',
  DocumentReference: '文件参考',
  ParentMOC: '父级变更',
  Action: '操作',
  Taggeditems: '标记项目',
  PrimaryHandover: '主要移交',
  SecondaryHandover: '二次移交',
  DetailedDescription: '详细描述',
  Response: '响应',
  ProposedSolution: '建议的解决方案',
  RequiresClarifcation: '需要澄清',
  EngineeringComplete: '工程设计完成',
  PACToBelssued: 'PAC将被起诉',
  NCRToBelssued: 'NCR将被起诉',
  OriginatorAcceptsProposal: '发起人接受提案',
  NotAnswered: '未回答',
  Rejected: '拒绝',
  lmpactNo: '合同编号',
  ActionsTaken: '采取的行动',
  ClosedDate: '关闭日期',

  ProposedAction: '提议的行动',
  // 数字文档
  PreviewTips: '预览仅用于演示目的。为了获得准确的表示，请生成PDF。',
  SaveRevision: '保存修订',
  SaveasNewRevision: '保存为新修订',
  Clonefrom: '克隆自',
  RemoverowButton: '删除',
  AddcolumnButton: '新增',
  ADDROWButton: '新增行',
  ADDNewTable: '新增表头',
  AddNewTask: '新增任务',
  NoComment: '无评论',
  InlineComment: '在线评论',
  LongCommnet: '长评论',

  Checkbox: '复选框',
  Signature: '签名',
  CheckboxSignature: '复选框签名',
  Date: '日期',
  DateCheckbox: '日期复选框',
  DateSignature: '日期签名',
  DateCheckboxSignature: '日期复选框签名',
  Table: '表格',
  Image: '图片',

  MultipleChoice: '多重选择',
  Addtitle: '新增标题',
  Required: '必填',
  weighting: '加权',
  AddNewSignoff: '添加新签名',
  Complete: '完成',
  Orientation: '方向',
  Portrait: '竖向',
  Landscape: '横向',
  HideComments: '隐藏评论',
  Optional: '可选',
  CheckboxOptions: '复选框选项',
  PreviewDocument: '预览文档',
  DownloadTemplate: '下载模版',
  CreateDocument: '创建文档',

  // 9-20
  HubUser: '用户',
  Position: '职位',
  Inactive: '激活',
  SignOffProcedures: '签署程序',
  SectionPermissions: '部分权限',
  SignOffWorkPacks: '签署工作包',
  SignOffOperations: '签署运维',
  SignOffTagITRs: '签署已编号检查测试表',
  SignOffPreservations: '签署维护保养',
  SignOffWorkPackApprovals: '签署工作包',
  ReviewAsBuiltDrawings: '审查竣工图',
  SignOffPunchListItems: '签署尾项',
  SignOffTestPacks: '签署测试包',
  SignOffJobCards: '签署工作卡',
  AcceptAsBuiltDrawings: '审批竣工图纸',
  SignOffMOC: '签署变更',
  SignOffHandovers: '签署节点证书',
  SignOffAssuranceTrackers: '签署保证跟踪表',
  Professions: '专业',
  // 9-23
  From: '来源',
  To: '至',
  SourceDrawing: '源绘图',
  LoopElement: '回路原件',
  SerialNumber: '序列号',
  Manufacturer: '制造商',
  ModelNumber: '型号',
  PurchaseOrderNumber: '采购订单号',
  DataSheetNumber: '数据表编号',
  FromGlandType: '从压盖类型',
  ToGlandType: '至压盖类型',
  Voltage: '电压',
  PulledLength: '拉动长度',
  IsValidated: '已验证',
  IsSafetyCriticalElement: '是安全关键要素',
  IgnoreEquipmentTypeToITR: '忽略ITR中的设备类型',

  // 9-24
  Approved: '被正式接受的',
  LocksWorkPack: '锁定工作包',
  Yes: '是',
  No: '否',
  // 9-27

  // 10-09
  DocumentCode: '文件代码',
  JobCardDrawing: '工作卡图纸',
  PercentComplete: '完成百分比',
  HideAdditionalFilters: '隐藏其它筛选器',
  ShowAdditionalFilters: '显示其它筛选器',
  ActualStartDate: '实际开始日期',
  ActualFinishDate: '实际完成日期',
  PlannedStartDate: '计划开始日期',
  PlannedFinishDate: '计划完成日期',
  CurrentEstimate: '当前估算',
  OriginalEstimate: '原始估算',

  RejectionReason: '拒收原因',
  SignedOffBy: '签字人',
  SignedOffDate: '签字日期',
  SignedOff: '已签字',
  NotSignedOff: '未签字',
  AcceptedBy: '审批人',
  AcceptedDate: '审批日期',
  Accepted: '已接受',
  NotAccepted: '未接受',
  AssignedDate: '分配日期',
  AssignedTo: '分配',
  Order: '订购',
  SubSystemPhase: '子系统阶段',
  SubSystemPriority: '子系统优先级',
  WorkPackAssignedTo: '分配给的工作包',
  WorkPackOriginator: '工作包发起人',
  WorkPackSignedOffBy: '工作包签字人',

  WorkPackTypeCoverSheetHandoverType: '工作包类型封面移交类型',
  // 10-10
  ITRClassHandoverGate: '检查测试记录表类别交接',
  ITRGenerationMethod: '检查测试记录表生成方法',
  IsMultiTagITR: '多标签编号设备单体ITR',
  ITRWitnessPoints: '检查测试记录表见证点',
  TaggedItemTagType: '标记项目标记类型',
  JobCardActivity: '工作卡活动',
  JobCardWorkPack: '工作卡工作包',
  ScheduleRevision: '计划修订',
  ScheduleGroup: '日程安排组',
  IssuedAsPaper: '以纸质/PDF版本发布',
  Any: '任何',
  TaggedItem: '编号资产',
  TaggedItemSubcontractorName: '标记项目分包商名称',
  SourceDrawingType: '源绘图类型',

  TaggedItemComments: '标记项目评论',

  IgnoreEquipmentTypeToPWL: '忽略设备类型对应的尾项清单',
  IsExRated: '是额定防爆',
  SignOffs: '签署',
  CompletedBy: '完成人',
  CompletedDate: '完成日期',
  Completed: '已完成',
  NotCompleted: '未完成',
  IssuedBy: '签发人',
  IssuedDate: '签发日期',
  Issued: '已签发',
  NotIssued: '未签发',
  DocType: '文件类型',
  // 10-11
  Year: '年/月/日',
  SearchPunchListItem: '搜索剩余工作清单项',
  TagITRAttachments: '编号设备单体ITR附件',
  TagAttachments: '编号设备单体附件',
  Editdigitaldocuments: '编辑数字文档',
  // 10-12
  PWLDocument: '尾项清单文件',

  EditDocument: '编辑文件',
  Label: '标记',
  SignOffType: '签字类型',
  Handovers: '如果该剩余工作清单项目类别未完成，则防止移交',
  Grouping: '分组',
  InUse: '使用中',
  PLICategoryDocument: '尾项清单尾项类型文件',
  GetBookmarkList: '获取书签列表',
  // 10-14
  IsOWLTask: '是OWL任务',
  PlannedDate: '计划日期',
  TaggedItemDiscipline: '标记项目专业',
  DueDate: '截止日期',
  EndDate: '结束日期',
  ClearedBy: '已清除',
  ClearedDate: '清除日期',
  Cleared: '已清除',
  NotCleared: '未清除',
  Number: '编号',
  // 10-16
  Notifications: '通知',
  // 10-17
  HeatTrace: '伴热',
  // 10-18
  DrawingTypeName: '图纸类型名称',
  SearchTagITRs: '搜索编号设备单体ITR',

  // 10-21
  PlannedStart: '计划开始',
  NotPlannedStart: '计划未开始',
  TotalTags: '资产数量',
  TotalITRs: '检查测试记录表条数',
  CompletedITRs: '已完成的检查测试记录表',
  OutstandingITRs: '未完成的检查测试记录表',
  ReviewedBy: '审核人',
  ReviewedDate: '审核日期',
  ArchivedSystemSignOffs: '归档系统验收',
  VerifiedBy: '验证人',
  VerifiedDate: '验证日期',
  ApprovedBy: '批准人',
  ApprovedDate: '批准日期',
  // WalkDowns: '现场检查',
  InspectedBy: '检查人',
  InspectedDate: '检查日期',
  TotalCount: '总数',
  TotalCompleted: '已完成的总数',
  TotalOutstanding: '未完成总数',

  File: '文件名称',
  RaiseMCCs: '新增机械完工移交证书',
  // 10-22
  RaiseDeleteMCCs: '提升/删除 机械完工移交证书',
  Raise: '提升',
  PlannedFinish: '计划完成',
  NotPlannedFinish: '未计划完成',
  // 10-23
  None: '没有',
  LastGeneratedDate: '上次生成日期',
  RejectReason: '拒绝原因',
  // 10-26
  AttachmentFile: '附件文件',
  AttachmentDescription: '附件说明',
  QPack: 'Q包',
  AsBuiltDrawingRevision: '竣工图纸修订',
  AttachmentDifferentToDocumentum: '附件与Documentum不同',
  PunchListItemNumber: '尾项清单尾项编号',
  AttachmentDocumentumID: '附件 Documentum ID',
  AttachmentDocumentumRootID: '根附件 Documentum ID',
  AttachmentFileExtension: '附件文件扩展名',
  AttachmentFileStatus: '附件文件状态',
  DocumentType: '文件类型',
  AttachmentLinks: '附件链接',
  Extension: '扩展名',
  FileStatus: '文件状态',

  // 10-28
  Generate: '生成',
  AcceptItems: '接受项目',
  Assign: '分配',
  AttachItemTo: '将项目附加到',
  ProvisionalNumber: '临时编号',
  AssignPunchListItem: '分配尾项清单尾项',
  SignaturePreview: '签名预览',
  Replace: '更换',
  ChangeFile: '变更文件',
  AddLink: '添加链接',
  AttachedTo: '关联到',
  Additionallinks: '所选项目具有其他链接。是否删除附件或链接？',
  DeleteAttachmentorLink: '是否删除附件或链接？',
  Close: '关闭',
  Disabled: '是否禁用',
  AddAlias: '添加别名',
  APSignaturesEnabled: '已启用授权人签名',
  CleanEnergy: '清洁能源',
  ECGrouping: '启用证书分组',
  // C级搜索区域的翻译
  EnableEx: '启用防爆',
  EnableMaterials: '启用材料',
  EnablePolarionID: '启用软件标识符',
  EnablePreservation: '启用保存',
  EnableProcedures: '启用程序',
  EnableProcessBuilder: '启用流程构建器',
  HideEmpty: '隐藏空的系统/子系统',
  LockImperiumFields: '锁定关键区域数据字段',
  MOCAutoNumbering: '变更自动编号',
  PreservationWindowAfter: '保存窗口之后',
  PreservationWindowBefore: '保存窗口之前',
  TaggedItemsCount: '编号资产数量',
  Features: '特征',
  PreservationProgressMethod: '保存进度的方法',
  StorageUsed: '已使用的内存',
  EnableAuthorisedPersonSignatures: '启用授权人签名',
  EnableCleanEnergy: '启用清洁能源',
  DigitalDocumentFooter: '数字文档页脚',
  EditFooter: '编辑页脚',
  SelectedFeatures: '选择特征',

  EnableHeaderFieldsReport: '启用标题字段报告',

  EnableHandoverRiskAssessmentFeature: '启用移交风险评估功能',
  EnableHandovers: '启用移交',
  EnableSubcontractorView: '启用分包商视图',
  ManualOperationNumbering: '手动操作编号',
  ModelConnection: '模型连接',
  PunchListMode: '尾项清单模式',
  QPacksMode: 'Q包模式',
  TagITRAutoAllocation: '编号设备单体ITR自动分配',
  TimeZone: '时区',
  EnablePrimaryandSecondaryHandovers: '启用主要和次要移交',
  DModelConnection: '三维模型连接',
  TagPWLAutoAllocation: '编号设备单体PWL自动分配',
  EnableManualNumberingofOperations: '启用手动操作编号',
  HandoverTypes: '移交类型',
  ConfiguredFeature: '配置功能',

  // 11-1
  RoleName: '角色名称',
  Describe: '说明',
  Defaultroleornot: '是否为默认角色',
  Menupermissions: '菜单权限',
  AddRole: '角色',

  // 11-4

  Status: '状态',
  Sex: '性别',
  Email: '邮箱',
  Phone: '手机',
  AccountNumber: '账号',
  UserName: '用户名',
  Reset: '重置',
  Pleaseenterusername: '请输入用户名',
  Pleaseenterphone: '请输入手机号',
  AddUser: '添加用户',
  MenuName: '菜单',
  Lastlogin: '最后登录',
  Namexing: '姓名',
  Cancel: '取消',

  GeneratePDF: '生成 PDF',
  Reject: '拒绝',
  AddImageButton: '增加图片',
  signOff: '签署',
  Confirm: '确认',

  RemoveTableButton: '移除表格',
  AddColumns: '新增列',
  tableLabel: '表格标签',
  TableBookmark: '表格书签',
  ColumnsOrderBy: '列排序方式',
  AddMultipleTasks: '添加多个任务',
  RemoveTitle: '移除标题',
  ConfigureTable: '配置表格',
  AddNewRow: '添加新行',
  CopyRow: '复制行',
  AddCell: '添加单元格',
  AddEmptyRow: '添加空行',
  GroupName: '分组名称',
  RoleDescription: '角色说明',
  GroupDescription: '分组描述',
  AssignUser: '分配用户',
  More: '更多',

  InterimAccepted: '临时验收',
  NotInterimAccepted: '暂不接受',
  InterimAcceptedBy: '临时接受人',

  Verified: '验证',
  NotVerified: '未验证',

  Reviewed: '审核',
  NotReviewed: '未审核',
  SigendOffDate: '结束日期',
  CertificationGrouping: '认证分组',
  InterimAcceptedDate: '临时验收日期',

  PartialHandovers: '部分移交',
  AddPartialHandovers: '添加部分移交',
  Add: '添加',
  Workshop: '车间',
  DocumentGenerate: '文档生成',
  FullHandoverDocument: '完整移交文件',
  GenerateHandoverDossier: '生成移交文档',
  SelectAll: '全选',
  WalkDowns: '巡检',
  RaiseSelected: '提升所选',
  RaiseSelectedAsMultiHandover: '将所选内容提升为多次移交',
  RaiseAllFromSearch: '从搜索中提升所有',
  Size: '大小',
  Source: '来源',
  UploadNew: '上传文件',
  SelectDocumentumFile: '选择文档文件',
  Added: '已添加',
  Deleteted: '已删除',
  Updated: '已更新',
  Invalid: '无效的',
  Unchanged: '未更改',
  Viewresults: '查看结果',
  PleaseselectanImportExportTable: '请选择导出/导入表',
  Pleaseselect: '请选择',
  ImportTitle: '导入',
  PleaseselectaFileToImport: '请选择要导入的文件',
  SelectFile: '选择文件',
  PleaseselectTypeofImport: '请选择导入文件类型',
  Validater: '数据验证',
  Simulate: '模拟导入',
  Full: '正式导入',
  ExportTitle: '导出',
  DownloadBlankTemplate: '下载空模板',
  SelectFormat: '选择格式',
  DownloadAllBlankTemplate: '下载全部空模板',
  ExportOptions: '导出选项',
  pleasechoosetheformatfordownload: '请选择下载格式',
  OK: '确定',
  FileName: '文件名',
  Deleted: '已删除',
  ImportSetting: '导入类型',
  ImportResult: '导入结果',
  DownloadResultFile: '下载结果文件',
  Users: '用户',
  RecordsProcessed: '已处理的记录',
  TotalAdded: '已添加总数',
  TotalDeleted: '已删除总数',
  TotalUpdated: '已更新总数',
  TotalInvalid: '无效总数',
  TotalNotProcessed: '未处理总数',
  TotalUnchanged: '未改变总数',
  ToBeAdded: '待添加',
  ToBeDeleted: '待删除',
  ToBeUpdated: '待更新',
  StoredAsJson: '存储为Json',
  ImportTable: '导入表单类型',
  AttachmentsPendingUpload: '待上传附件',
  UploadAll: '全部上传',
  UseDocumentCode: '使用文档代码',
  Defaultsginoffs: '审批管理',
  Type: '类型',
  RemoveSignOff: '删除注销',
  EditTagITR: '编辑编号设备单体ITR',
  EditPunchListItem: '编辑尾项清单尾项',
  EditTagPWL: '编辑编号尾项清单',
  EditWorkPack: '编辑工作包',
  MOC: '变更',
  EditMOC: '编辑变更',
  AssuranceTracker: '保证跟踪',
  EditAssuranceTracker: '编辑保证跟踪',
  Require: '需求',
  TotalAccepted: '完全接受',
  AddDOTXTemplate: '添加DOTX模板',
  SelectOptions: '选择选项',
  Pleasechoose: '请选择要导出的列',
  Cores: '核心',
  IgnoreEquipment: '忽略设备',
  HandoverByEntity: '按实体移交',
  Gates: '门控',
  InterimDates: '临时日期',
  PartialHandover: '部分交接',
  MultiHandover: '多交接',
  TrackWalkdowns: '跟踪巡视',
  ShowOnFrontScreen: '在前屏幕上显示',
  ShowIncludesExcludes: '显示包含排除',
  HandoverGates: '移交门控',
  HandoverAddEditDocument: '编辑移交文档',
  HandoverPreviewDocument: '预览移交文档',
  WithAttachments: '附件',
  LookupDocumentCode: '查找文档代码',

  ExistingHandovers: '现有移交',
  EditSignOffs: '编辑签署',
  preservationCompletionStatus: '保存完成状态',
  SigneOffLocation: '签署地点',

  Frequency: '频率',
  SignerNameAndDateRequired: '签署人姓名和日期不能为空',
  ImportsDigitalDocument: '导入数字文档',

  NoOfPersonnel: '人员数量',

  OperationProgressMethod: '操作进度方法',

  WorkOrderDetails: '工单详细信息',

  // 多选是没有选择任何项
  NotSelected: '未选择任何项。请选择一个项。',
  // 删除成功
  DeleteSuccessfully: '删除成功',
  // 操作成功
  OperationSuccessful: '操作成功',
  // 操作失败
  Operationfailed: '操作失败',

  LocksJobCard: '锁定工作卡',
  EstimatedHours: '预计小时数',
  TagITRTaggedItem: '编号设备单体ITR的标记项目',
  JobCardDescription: '工作卡描述',
  Narrative: '叙述',
  ApprovalComments: '审批意见',
  ReorderAttachments: '重排附件',
  AddJobCard: '添加工作卡',
  TagType: '编号设备单体类型',

  ProcedureName: '程序名称',
  UnitOfMeasure: '单位',
  Contractor: '承包商',
  TestPressure: '测试压力',
  TestMedium: '测试中等',
  TestDuration: '测试时长',
  DateAddedToTagSet: '添加日期标签集',
  DateRemovedFromTagSet: '从标记中删除的日期',
  ExportTaggedItemDrawings: '导出标记项目的图纸',
  ExportTaggedItemITRs: '导出标记项目的检查记录表',
  ExportTaggedItemProcedures: '导出标记项目的程序',
  ExportTaggedItemPWLs: '导出标记项目的尾项清单',
  ExportTags: '导出编号设备单体',
  ExportCables: '导出电缆',
  ExportTestPackMechanicalJoints: '导出机械连接测试包',
  NumberOfBolts: '螺栓数量',
  ScheduledReportReportFilter: '计划报告过滤器',
  DocumentFormat: '文档格式',
  GeneratedAt: '生成时间',
  ReportOptions: '报告选项',
  Pleasechoosethepageorientation: '请选择页面方向',
  Pleasechoosethepagesize: '请选择页面大小',
  RunPDF: '运行 PDF',
  RunExcel: '运行 Excel',
  ReportGroup: '报告组',
  ScheduledReportReport: '计划报告',
  MaxDocumentsToRetain: '保留最大的文档数',
  Scheduled: '计划',
  Every: '每',
  Week: '周',
  On: '在',
  At: '在',
  EverydayoftheWeek: '每周的每一天',
  EmailAddresses: '电子邮箱地址',
  SelectAReport: '选择报告',
  Filters: '过滤器',
  EditFilters: '编辑过滤器',
  RemovePreviousReports: '删除以前的报告',

  LockDigitalDocumentComments: '锁定数字文档评论',
  CountryName: '国家名称',
  CountryNameEn: '国家英文名称',
  CountryCode: '国家代码',
  TaggedItemsLimit: '编号资产限制', 
  AutoNumberPunchListItems: '自动编号检查清单项目',

  EnablePrimaryAndSecondaryHandovers: '启用主备切换',

  EnableManualNumberingOfOperations: '启用操作的手动编号',
  EnableAssurance: '启用保证',
  Engineering: '数据库配置',
  Entity: '实体',
  EnableCertificationGrouping: '启用认证分组',
  EditFooterforTutorial: '编辑教程页脚',
  Left: '左边',
  LeftText: '左边文本',
  Centre: '中心',
  CentreText: '中心文本',
  Right: '右边',
  RightText: '右边文本',
  FooterTutorial: '页脚教程',
  FooterHistory: '页脚历史',
  ThirdPartyBy: '第三方',
  ThirdPartyDate: '第三方日期',
  RaiseDeleteCCCs: '提升/删除 施工移交证书',
  RaiseCCC: '提升施工移交证书',
  RaiseRFSU: '提升启动证书',
  HandoverTypeDocument: '移交类型文件',
  HandoverTypeCoverSheet: '移交类型封面',
  FilterReport: '筛选报告',
  Attachmentdeletionsuccessful: '附件删除成功',
  Scope: '范围',
  DownloadSmartGoDataDictionary: '下载数据字典',
  SmartGoDataDictionary: '有关信息加载顺序及各表的说明，请参阅SmartGo数据字典。点击下载',
  ProjectList: '项目列表',
  Projectnotfound: '暂无项目',
  Pleasetrycreatinganewproject: '请尝试创建新项目',
  Newproject: '新建项目',
  SystemManagement: '系统管理',
  DataDictionary: '数据字典',
  nickname: '昵称',
  surname: '姓',
  name: '姓名',
  password: '密码',
  profile: '简介',
  country: '国家',
  language: '语言',
  English: '英语',
  Chinese: '简体中文',
  Enable: '启用',
  Disable: '禁用',
  LoginSuccessful: '登录成功',
  LoginFailed: '登录失败',
  LogoutSuccessful: '登出成功',
  UserInfo: '个人信息',
  Datamodification: '资料修改',
  Basicinformation: '基本信息',
  PasswordRest: '密码修改',
  Oldpassword: '旧密码',
  Newpassword: '新密码',
  Confirmpassword: '确认密码',
  Permissioncharacters: '权限字符',
  Chinesename: '中文名称',
  PermissionManagement: '权限管理',
  Icon: '图标',
  MenuNameCN: '菜单名称(中文)',
  Sort: '排序',
  Editmenu: '编辑菜单',
  TopMenu: '上级菜单',
  MenuType: '菜单类型',
  MenuMing: '菜单名称(中文)',
  AssignedTagPWLs: '维护保养',
  Thispermissionhasbeenassigned: '该权限已分配',
  AssignPermissions: '分配权限',
  RoleList: '角色列表',
  RolesAssign: '角色分配',
  Fileverificationpassed: '文件验证通过',
  Unabletoreadfile: '无法读取文件',
  FileFormat: '无法导入此文件。文件必须为.csv或.xlsx格式。',
  FileEmpty: '文件中没有数据。请检查并上传一个有效的文件。',
  ConfirmDelete: '确定删除',
  DataDelete: '确定删除这条数据吗?',
  AginRole: '该角色已被分配',
  CharacterOperationSuccessful: '角色分配成功',
  RoleUnbindingFailed: '角色解绑失败，请稍后重试',
  SelectedRole: '已分配角色',
  ExpandCollapse: '展开/收起',
  SelectAllSelectNone: '全选/全不选',
  AssignedMenu: '分配菜单',
  Directory: '目录',
  MeNu: '菜单',
  // 2025-4-23
  PleaseselectatabletoExport: '请选择要导出的表',
  PermissionName: '权限名称',
  PermissionIdentifier: '权限标识',
  MenuStatus: '菜单状态',
  Show: '显示',
  Hide: '隐藏',
  ParentMenu: '父级菜单',
  PrerequisiteProcedure: '前置步骤',
  DocumentOwner: '文档所有者',
  CheckedBy: '检查人',
  Transmittal: '传送',
  AdditionalInformation: '附加信息',
  AuthorisedStartedDate: '授权开始日期',
  CheckedDate: '检查日期',
  DocumentRequiredByDate: '所需文件截止日期',
  Title: '标题',
  ParentProcedureSkeletonSection: '父程序大纲分段',
  ProcedureSkeletonSectionNumber: '编号',
  TransmittalNumber: '传输编号',
  ParentProcedureSection: '父级程序段',
  ProcedureSectionNumber: '程序章节编号',
  ProcedureStepNumber: '程序步骤编号',
  DeleteOperationCanceled: '删除操作已取消',
  PleaseEnterOldPassword: '请输入旧密码',
  Passwordresetsuccessfully: '密码重置成功',
  Passwordresetfailed: '重置密码失败',
  OkPassword: '确定',

  //5-20
  ClosedBy: '关闭人',
  AnsweredBy: '答复人',
  AnsweredDate: '答复日期',
  ClarificationDetails: '澄清细节',
  ImpactNo: '是否影响',
  ProcedureDrawing: '程序图纸',
  PACToBeIssued: 'PAC将被签发',
  NCRToBelssued: 'NCR将被签发',
  //5-22
  TagPWLTaggedItem: '编号尾项清单标记项目',
  TagPWLTaggedItemLocation: '编号尾项清单标记项目位置',
  TagPWLFrequency: '编号尾项清单频率',
  ExportAsTagPWLs: '导出为编号尾项清单',
  SelectColumns: '选择列',
  //5-26
  AsBuiltDrawings: '竣工图',
  IsDraft: '是否为草稿',
  ViewBoard: '查看看板',
  //5-28
  NotStarted: '未开始',
  InProgress: '进行中',
  ChecksheetComplete: '检查表完成',
  //5-30
  TrackerType: '追踪器类型',
  PlannedDueDate: '计划截止日期',
  //6-3
  AuthorisedPersonProfession: '授权人员专业',
  AuthorisedPersonDiscipline: '授权人员学科',
  TrackerCategory: '跟踪表类别',
  TrackerSubCategory: '跟踪表子类别',
  TrackerType: '跟踪表类型',
  //6-4
  AuthorisedPersonSubcontractorName: '授权分包商名称',
  AssignedToNotificationGroup: '分配给通知组',
  IssuedAsPaperOrPdfVersion: '以纸质或Pdf版本发布',
  //6-9
  ExportAsTagITRs: '导出为标签ITR',
  ChooseColumns: '选择列',
  Back: '返回',
  OVERALL: '全部',
  HandoverCont: '移交',
  BOARD: '看板',
  //6-16
  IsComplete: '已完成',
  Weighting: '权重',
  //6-19
  PunchListItemCompletionStatus: '尾项类别状态',
  IsDefaultStatus: '是否为默认状态',
  IsRejected: '是否拒绝',
  AssuranceTrackerCompletionStatus: '保证跟踪器完成状态',
  //6-23
  ExportAsTagPWLs: '导出为标签PWL',
  //7-9
  PulledLengthUnit: '拉力长度单位',
  //7-18
  AddCheckBox: '添加复选框',
  CheckBoxLabels: '复选框标签',
  PunchListCheckBox: '尾项清单复选框',
  TRANSLATE: '复选框名称有3个字符的限制',

  //7-28
  Certificate: '节点证书',
  Certificates: '节点证书',
  ITRCheckSheet: '检查测试表',

  //7-31
  SigninwithyourSmartGoAccount: '使用您的SmartGo帐户登录',
  RememberMe: '记住我',
  Forgotyourpassword: '忘记密码',
  EnteryourEmail: '输入您的电子邮件',
  Enteryourpassword: '输入您的密码',
  EnterPassword: '请输入密码',
  Signin: '登录',
  Workbenches: '工作台',
  FullScreen: '全屏模式',
  ExitFullScreen: '退出全屏',
  UserCenter: '用户中心',
  LogOut: '退出登录',
  CloseAll: '全部关闭',
  CloseOther: '关闭其它',
  Entersomething: '输入内容',
  Roles: '角色',
  PermissionList: '权限列表',

  AssignedTagITRs: '已分配编号设备单体ITR',
  NoCertificateDataAvailable: '没有节点证书数据',
  TAGITRS: '已编号检查测试表',
  NoTAGITRSDataAvailable: '没有编号设备单体ITR数据',
  PUNCHLISTITEM: '尾项',
  NoPUNCHLISTITEMSDataAvailable: '没有尾项数据',
  MOCS: '变更',
  NoMOCDataAvailable: '没有变更数据',
  NoPLANNEDVSACTUALPROGRESSDataAvailable: '没有实际进度与计划进度数据',
  Total: '总数',
  Completed: '已完成',
  TotalITRs: '检查测试表条数',
  TotalPILs: 'PLIs 总数',
  TotalMOCs: 'MOCs 总数',
  SKYLINEOUTSTANDINGUPCOMING: '天际线图：进行中与即将开始',
  NoSKYLINEDataAvailable: '没有天际线数据',
  PLANNEDVSACTUALPROGRESS: '计划进度与实际进度',
  TagPWLsTotal: '维护保养总数',
  SELECTTYPE: '选择模版类型',
  Nofile: '未上传任何文件。请选择一个文件',
  PleaseselectTable: '请选择一个表格',
  Fileandtable: '文件和表不匹配。请检查并重试。',
  AnFile: '验证文件时出错。',
  Fileverification: '文件验证失败，请仔细检查。',
  FileContains: '该文件不包含标记为必填的字段',
  homeList: {
    assignedTagITRs: "已编号检查测试表",
    assignedPunchListItems: "尾项",
    assignedCertificate: "节点证书",
    assignedTagPWLs: "维护保养",
    assignedORA: "运行准备与保障",
    complete: "已完成",
  },
  // 2025-08-01
  SureWant: '您确定要退出登录吗？',
  PleaseSelectFile: '请选择文件',
  AddItems: '添加项目',
  RowsLoaded: '已加载行',
  ExCertifyingBody: '防爆证书颁发机构',
  ExRatedModel: '额定防爆类型',
  // 搜索
  SimpleSearch: '简单搜索',
  AdvancedSearch: '高级搜索',
  RefreshView: '刷新视图',
  FromCreatedDate: '自创建日期起',
  ToCreatedDate: '截止创建日期',
  CreatedDate: '创建日期',
  FromUpdatedDate: '自更新日期起',
  ToUpdatedDate: '截止更新日期',
  SelectDate: '选择日期',
  Theprimaryidentifierforanitem: '项目的主要标识符。',
  Ageneraldescriptionoftheitem: '项目的一般描述。',
  Datetheitemwasadded: '添加项目的日期。“自创建日期起”和“截止创建日期”可用于指定范围。',
  Datetheitemwaslastupdated: '项目上次更新的日期。“自更新日期起”和“截止更新日期”可用于指定范围。',
  FromSignedOffDate: '起始签署日期',
  ToSignedOffDate: '截止签署日期',
  TagITRComments: '编号设备单体ITR评论',
  FromLastGeneratedDate: '从上次生成日期开始',
  ToLastGeneratedDate: '截止上次生成日期',
  TagITRsSubcontractorName: '编号设备单体ITR分包商',
  InspectionandTestRecords: '检验和测试记录（ITR）是一种记录（传统上是纸质清单，但越来越多地以数字形式提供），用于证书标记的设备已由经批准的合格人员按照商定的流程和程序正确建造和测试。ITR（也称为检查表、计数表和证书）包括应完成的任务、测量和活动清单，以验证相关设备的状态。虽然ITR的设计、内容、命名和术语因不同公司、地点和项目而异，但它们的最终目的是相同的：确保被认证设备的安全。',
  TestReferenceisan: '测试参考是一个可选字段，允许区分分配给同一标签的同一类型的两个ITR（例如QED-A01A）。在测试参考中输入的值的示例可能是\u0027陆上\u0027-Offshore \u0027-重新测试\u0027,\u00271\u0027\u0027]、\u00272\u0027:\u00273\u0027。',
  EforElectrical: '项目的纪律。\n\n学科代表个人可能专门从事或承担责任的行业或专业领域，也用于对设备进行分类。常见的学科包括电气、机械、安全、消防、气体等。\n\n这些通常使用单个字母命名，例如E表示电气。',
  TheITRClass: 'ITR类别通常用于表示ITR适用的一般阶段或活动，最常见的ITR类别是MC和PC（指机械竣工和预调试）或CN和CM（指施工和调试）。根据需要，还可以使用各种其他ITR类。',
  TheDiscipline: '项目的纪律。\n\n学科代表个人可能专门从事或承担责任的行业或专业领域，也用于对设备进行分类。常见的学科包括电气、机械、安全、消防、气体等。\n\n这些通常使用单个字母命名，例如E表示电气。',
  ASystemis: '系统是一个功能对象，它本身是一组功能对象（子系统）的集合，形成一个网络来提供一种服务或服务于一个共同的目的。\n\n值得注意的是，系统内的对象不必物理连接。',
  Thenameof: '签署项目或文件的授权人的姓名。',
  ASubsystemis: '子系统是一个功能对象，表示服务于共同目的的项目集合。\n\n与系统一样，项目本身不必进行物理连接。认证组提供了一种按子系统和专业将标签ITR关联在一起进行移交的方法。',
  Thedateon: '项目签收的日期。\u0027“从签收日期开始”和“到签收日期”可用于指定范围。',
  Phasesprovide: '阶段提供了一种方法，可以将C级细分为不同的工作时间段。',
  Inliteralterms: '阶段提供了一种方法，可以将C级细分为不同的工作时间段。',
  Proceduresanddrawings: '工作卡（也称为工作包）代表了工作包的进一步细分，以及在设施中要进行的详细工作。它们的存在是为了授权和指导工人执行所列任务，并包含任务指南、安全信息和其他相关文件，如检查程序和图纸。',
  Usedtouniquely: '文档代码用于唯一标识hub2中的每个文档。每次移交、剩余工作清单项目、标签PWL和标签ITR都会收到一个唯一的文件代码。',
  Commentsfield: '注释字段可用于记录与标签ITR相关的任何杂项信息',
  ExamplesofEquipment: '设备类型表示设备项目的一般分类，并允许通过设备类型到ITR表根据此分类分配（或推荐）ITR。设备类型的常见示例包括接线盒、变送器、配电板和阀门',
  Canbeused: '设备状态可用于进一步划分一组具有相同设备类型的标签。设备状态的目的只是为了对ITR分配/建议的设备类型进行更详细和精细的控制，因此该字段是可选的。',
  Setofusers: '“描述”：“分包商名称是一个可选字段，允许区分分配给特定用户组的不同工作范围。”',
  Locationdenotes: '位置表示项目占用的物理空间。',
  AParent: '父标记是一种分组（可从参考表中获得），可用于表示相关的标记项目的集合，或者在一起构成一个更大的功能对象。',
  Thecomments: '注释字段可用于记录与项目相关的任何杂项信息。',
  Canhave: '标记的项目可以勾选“忽略设备类型是否符合ITR”，以允许将其排除在“设备类型是否满足ITR”表定义的自动分配/建议规则之外。',
  SourceDrawingrefers: '源图纸是指主要标识所讨论项目的图纸。',
  Convention: '图纸的类型。\n\n图纸可以涵盖一系列不同类型的插图，包括等距图、工艺和仪表图以及总布置图等。它们用于以各种方式直观地传达信息，所使用的绘图类型由惯例和最有效地满足所需目的的方式决定。',
  Commissionanobject: '过程是一组逻辑顺序的指令，用于执行一类活动。\n\n可能有许多不同类型的程序，hub2中的主要程序是调试程序，这是一个对所需活动进行逐步描述的程序。程序是一组逻辑顺序的指令，用于执行一类活动。\n\n可能有许多不同类型的程序，hub2中的主要程序是调试程序，这是一个逐步描述调试对象所需活动的程序。',
  TheTypeof: '程序的类型。\n\n过程是一组逻辑顺序的指令，用于执行一类活动。\n\n可能有许多不同类型的程序，hub2中的主要程序是调试程序，这是一个逐步描述调试对象所需活动的程序。',
  Datetheitem: '添加项目的日期。\u0027“自创建日期起”和“截止创建日期”可用于指定范围。',
  SpecifyA: "项目上次更新的日期。\u0027“自更新日期”\u0027-\u0027“截止更新日期”\u0027\可用于指定范围。",
  CabelATagrepresents: "标签代表设施内物理设备提供的功能，其名称“标签”来自为识别目的分配（通常物理附着）到设备上的设备标签。虽然这确实意味着，从字面上看，标签就是标签本身，但它通常用于指代设备的功能。应注意的是，如果更换了设备或设备的一部分，这并不构成不同的标签。因此，如果标签“A”是一台序列号为“0001”的压缩机，并且被序列号为“0002”的压缩机所取代，那么它仍然是标签“A”。",
  Disciplinerepresents: '专业代表了个人可能专门从事或承担责任的行业或专业领域，也用于对设备进行分类。常见的学科包括电气、机械、安全、消防、气体等。\n\n这些通常使用单个字母命名，例如E表示电气。',
  SubcontractorNameisanoptional: '分包商名称是一个可选字段，允许区分分配给特定用户组的不同工作范围。',
  Thephysical: '物品来源的物理空间',
  Manydifferent: '过程是一组逻辑顺序的指令，用于执行一类活动。\n\n可能有许多不同类型的程序，hub2中的主要程序是调试程序，这是一个逐步描述调试对象所需活动的程序。',
  Representsfunctionality: '标签代表设施内物理设备提供的功能，名称\u0027Tag\u0027来源于为识别目的分配（通常物理附着）给设备的设备标签。\n\n虽然这确实意味着，从字面上看，标签就是标签本身，但它通常用于指代设备的功能。\n\n应注意的是，如果更换了设备或设备的一部分，这并不构成不同的标签。\n\n因此，如果标签\u0027A\u0027是序列号为\u00270001\ u 0027的压缩机，并且被序列号为\ u00270002\ u 00227的压缩机所取代，它仍然是标签\u0017A\ u 0027。',
  InspectionAnd: '检验和测试记录（ITR）是一种记录（传统上是纸质清单，但越来越多地以数字形式提供），用于证明标记的设备已由经批准的合格人员按照商定的流程和程序正确建造和测试。ITR（也称为检查表、计数表和证书）包括应完成的任务、测量和活动清单，以验证相关设备的状态。\n\n虽然ITR的设计、内容、命名和术语因不同公司、地点和项目而异，但它们的最终目的是相同的：确保被认证设备的安全',
  ItemThephysical: '项目终止的物理空间。',
  Whetherapipe: '管道是否由伴热（也称为表面加热）系统支撑，以确保其保持在正确的温度。',
  Thedimensionsoftheitem: '项目的尺寸',
  ALineIs: '管线被定义为一段管道。线路可以通过线轴连接；带有配件的短管段，允许一条管线连接到另一条管线。与线轴一样，线路也可以是测试包的一部分。',
  Howmanybolts: '连接这个接头需要多少个螺栓',
  Itemwassignedoff: '项目签字的日期',
  TheHandoverGating: '移交门控决定了整个项目中移交的范围和顺序，有助于回答以下问题：本次移交涵盖了哪些证书/ITR，以及在整个移交过程中，本次特定移交应在何时进行？\n\n这两个问题都用一个字段来回答：交接门编号。\n\n此字段既是移交和ITR类之间的链接，也是在项目内订购移交的手段。ITR类别通常用于表示ITR适用的一般阶段或活动，最常见的ITR类别是MC和PC（指机械竣工和预调试）或CN和CM（指施工和调试）。根据需要，还可以使用各种其他ITR类。',
  Approvedandcompetent: '检验和测试记录（ITR）的专业。\n\n检验和测试记录（ITR）是一种记录（传统上是基于纸张的检查表，但越来越多地以数字形式提供），用于证明标记的设备已由经批准的合格人员按照商定的流程和程序正确构建和测试。\n\n纪律代表个人可能专门从事或承担责任的行业或专业领域，也用于对设备进行分类。常见的学科包括电气、机械、安全、消防和燃气等。这些通常使用单个字母命名，例如E代表电气。',
  Actvitiywithin: 'hub2中的活动表示推荐的工作分解结构中的第3级，因此作为工作卡的父级和E级的子级存在。\n\n术语“活动”通常与工作包或工作包互换使用，但hub2将它们视为单独但等效的。\n\n该活动旨在代表计划组件，因此代表一段使用的时间（在更大的工作范围内），而不是一份实物文件。',
  Recommendeddata: '工作卡的父级工作包。\n\n工作包（也称为工作包、施工工作包和施工工作包）是项目工作分解结构（WBS）中的最低层级，用于在工作范围内对任务进行分组（若遵循推荐的数据填充指南，则对应于hub2数据结构的E级）。\n\n从字面上理解，工作包是在项目计划规定的时间范围内完成一组任务所需的文件集合。这将包括要完成的任务以及完成任务所需的设备和材料。\n\n工作包的汇编被认为是项目管理中最耗时的方面之一。',
  FromAcceptedDate: '自接收日期',
  ToAcceptedDate: '截止接收日期',
  FromIssuedDate: '自发放日期',
  ToIssuedDate: '截止发放日期',
  FromCompletedDate: '自完成日期',
  ToCompletedDate: '截止完成日期',
  IssuedAsPaperPDFVersion: '发行为纸张/PDF版本',
  Longerandmore: '更长、更详细的描述，适用于MOC和剩余工作清单项目等项目',
  PunchListisagrouping: '剩余工作清单是一组剩余工作清单项目（通常称为“PLI”）。\n\n剩余工作清单项目用于记录之前应完成的未完成工作项目。\n\n这可能包括管道上缺少隔热层或伴热、涂漆不完整或需要补漆、仪器或接线盒接地不良等',
  Arrangement: '尾项清单项目被分配一个尾项清单类别，该类别通常用于指示缺陷的严重程度。\n\n一种常见且简单的安排是创建两个尾项清单项目类别，一个名为“A”，另一个名为“B”。类别“A”用于与安全相关的缺陷，而“B”用于其他缺陷。\n\n然而，定义尾项清单项目类别的能力完全取决于用户，因此可能与上述示例完全不同，该示例仅提供一般信息，并不构成对此主题的指导。',
  Disciplinerepresents: '项目的学科。\n\n学科代表个人可能专攻或负责的行业或专业领域，也用于对设备进行分类。常见的学科示例包括电气、机械、安全、消防与燃气等。\n\n这些学科通常以单个字母命名，如E代表电气。',
  TestReferenceAD: '“测试参考”是一个可选字段，用于区分分配给同一标签的同类型（如QED-A01A）的两个ITR。在“测试参考”中输入的示例值可能包括“陆上”、“海上”、“复测”、“1”、“2”、“3”等。',
  PreservationWorkLists: '保护工作清单（PWL）用于记录保护任务的完成情况，可以按照与ITR类似的方式分配给标签。\n\n不同之处在于，PWL是未使用设备定期维护计划的一部分，而ITR用于确认安装的设备是安全的，并且已经作为移交过程的一部分进行了适当的测试（最终目标是启动或重新启动设施）。',
  OutstandingWork: '未完成工作清单（OWL）和OWL任务用于记录移交前已被确定为不完整的工作。\n\n这与剩余工作清单和PL项目形成对比，后者用于捕获以前未识别的未完成工作。',
  Thenameof: '接受完整项目或文件的授权人的姓名。',
  Thedate: '项目被验收为完成的日期',
  WorkItem: '分配给某项任务或工作项目的时间量。',
  PreservationWork: '此物品保存工作应停止的日期。',
  FromRaisedDate: '自提出日期起',
  ToRaisedDate: '截止提出日期',
  FromPlannedDate: '自计划日期起',
  ToPlannedDate: '截止计划日期',
  FromDueDate: '自到期日起',
  ToDueDate: '截止到期日',
  FromEndDate: '自结束日期起',
  ToEndDate: '截止结束日期',
  FromClearedDate: '自清算日期起',
  ToClearedDate: '截止清算日期',
  HandoverCertificates: '移交证书，通常简称为移交证书，用于在当局之间转移责任时保证技术完整性。',
  Miscellanousinformationrelated: '与移交相关的其他信息可以存储在“注释”字段中。',
  Authorityisscheduledtobegin: '计划开始移交权力的日期',
  Authorityisscheduledtofinish: '计划完成权力移交的日期',
  Willbereturned: '勾选后，只有与已完成的ITR相关的移交（有“完成人”和“完成日期”的移交）才会被退回',
  FromPlannedStartDate: '自计划开始日期起',
  ToPlannedStartDate: '截止计划日期',
  FromPlannedFinishDate: '自计划完成日期起',
  ToPlannedFinishDate: '截止计划完成日期',
  FromReviewedDate: '自审核日期起',
  ToReviewedDate: '截止审核日期',
  ThefullfilenameforanAttachment: '附件的完整文件名。',
  ThedescriptionofanuploadedAttachmentfile: '已绘制附件文件的说明。',
  Unusedequipment: '保护工作清单（PWL）用于记录保护任务的完成情况，可以按照与ITR类似的方式分配给标签。\n\n不同之处在于，PWL是未使用设备定期维护计划的一部分，而ITR用于确认安装的设备是安全的，并且已经作为移交过程的一部分进行了适当的测试（最终目标是启动或重新启动设施）。',
  AQuality: '质量包（Q包）是质量步骤或任务的集合，必须为单个标记项目完成这些步骤或任务。',
  ManagementofChange: '变更管理（MOC）是跟踪与原始范围/设计的潜在偏差的过程。',
  Programshould: '文件扩展名是文件名中句号之后的部分。例如，在Help.txt文件中，扩展名为.txt。\n\n文件扩展名标识文件中存储的信息类型以及应使用什么程序打开它。',
  Detailed: '详细',
  Summary: '总结',
  Misc: '其它',
  NoHandoverhasaPlannedFinishDateset: '没有设置计划完成日期的移交记录',
  LevelAisrepresents: 'A级是\u0027company\u0027/\u0027-tenant \u0027级别，表示全公司\u0027-的设置。',
  Sandpit: '测试环境',
  Procedureswhenverifying: '完成该项目的授权人的姓名。\n\n通常用于在验证项目的完成状态时标记ITR、测试包和程序',
  Itemwascompleted: '项目完成的日期。\n\n通常用于在验证项目的完成状态时标记ITR、测试包和程序。',
  ProcedureSystem: '程序系统',
  FromActualStartDate: '自实际日期起',
  ToActualStartDate: '截止实际日期',
  Author: '发起人',
  FromAuthorStartedDate: '自发起人日期起',
  ToAuthorStartedDate: '截止发起人日期',
  AuthorStartedDate: '发起人开始日期',
  ApprovedForIssueBy: '批准发布人',
  FromCheckedDate: '自检查日期起',
  FromApprovedForIssueDate: '自批准发布日期起',
  ToApprovedForIssueDate: '截止批准发布日期',
  ApprovedForIssueDate: '批准发布日期',
  FromExecutionActualStartDate: '自执行实际日期起',
  ToExecutionActualStartDate: '截止执行实际日期',
  ExecutionActualStartDate: '执行实际开始日期',
  FromDocumentRequiredByDate: '自文档要求日期起',
  ToDocumentRequiredByDate: '截止文档要求日期',
  ProcedureDrawingType: '程序图纸类型',
  ToCheckedDate: '截止检查日期',
  Proceduresarecommonlysub: '程序通常被细分为单独的部分，在hub2中通过程序部分表示。',
  Nameofthe: '完成程序部分的被授权人的姓名。',
  Helevelabove: '完成本程序部分父母（以上级别）的授权人姓名',
  RaisePLs: '提升 PLs',
  FromRevisionDate: '自修订日期起',
  ToRevisionDate: '截止修订日期',
  TheDisciplineof: '检验和测试记录（ITR）的纪律。\n\n检验和测试记录（ITR）是一种记录（传统上是基于纸张的检查表，但越来越多地以数字形式提供），用于证明标记的设备已由经批准的合格人员按照商定的流程和程序正确构建和测试。\n\n纪律代表个人可能专门从事或承担责任的行业或专业领域，也用于对设备进行分类。常见的学科包括电气、机械、安全、消防、气体等。这些通常使用单个字母命名，例如E代表电气。',
  TheITRClass: 'ITR类别通常用于表示ITR适用的一般阶段或活动，最常见的ITR类别是MC和PC（指机械竣工和预调试）或CN和CM（指施工和调试）。\n\n根据需要，还可以使用各种其他ITR类。',
  ThedefaultCompletionStatus: '为了方便起见，会自动选择默认的“完成状态”。如果用户需要不同的完成状态，则必须手动更改字段。',
  Denoteswhetherthedocument: '表示文档是从数字模板（从hub2的数字文档部分创建和管理）生成的，还是从文字处理程序中创建的外部模板生成的。',
  DigitalDocumentPartial: '数字文档部分',
  TheHandoverGatingdetermines: '移交门控决定了整个项目中移交的范围和顺序，用于回答以下问题：本次移交涵盖哪些证书/ITR，以及在整个移交过程中，本次特定移交应在何时进行？\n\n这两个问题都用一个字段来回答：交接门编号。\n\n此字段既是移交和ITR类之间的链接，也是在项目内订购移交的手段。',
  StartDate: '开始日期',
  Controlover: '生产线的设备状态。\n\n设备状态可用于进一步划分一组具有相同设备类型的标签。设备状态的目的只是为了对ITR分配/建议的设备类型进行更详细和精细的控制，因此该字段是可选的。',
  Whentheitemisexpected: '当项目预计由以下人员签字时',
  Describeshowregularly: '描述任务的执行频率。例如，频率为7意味着任务应该每周执行一次。',
  ATagrepresents: "标签代表设施内物理设备提供的功能，其名称“标签”来自为识别目的分配（通常物理附着）到设备上的设备标签。\n\n虽然这确实意味着，从字面上看，标签就是标签本身，但它通常用于指代设备的功能。\n\n应注意的是，如果更换了设备或设备的一部分，这并不构成不同的标签。\n\n因此，如果标签“A”是序列号为“0001”的压缩机，并且被序列号为”0002“的压缩机所取代，则它仍然是标签”A“。",
  Shouldcease: '当与该项目相关的工作应该停止时。',
  Punch: '尾项',
  NoITRCheckSheetDataAvailable: '没有检查测试表数据',
  Thephysicallocation: '被保存物品的物理位置。',
  Whocompleted: '完成程序的被授权人的姓名。',
  SpecificCategorisation: '标记物品的具体分类，例如电缆、机械接头、测试包等。',
  FromStartDate: '起始日期',
  ExpectedTime: '预期时间',
  ToStartDate: '开始时间到',
  // 2025-08-04
  LeftImage: '左侧图片',
  RightImage: '右侧图片',
  UploadFiles: '上传文件',
  // 2025-08-05
  AddNewSignoffs: '添加新的签署',
  Update: '更新',
  AddHandoverType: "添加移交类型",
  ConfiguredFeatures: "功能配置",
  Select: '选择',
  PunchListItemAutoNumber: '尾项清单自动编号',
  Prefix: '前缀',
  Suffix: '后缀',
  NumberLength: '编号长度',
  Enforcement: '约束',
  SubSystemAttachments: '子系统附件',
  SystemAttachments: '系统附件',
  CableAttachments: '电缆附件',
  Loginexpirationreminder: '登录过期提醒',
  Yourlogin: '您的登录信息已过期，请重新登录',
  Clearall: '全部清除',
  ALLProject: '所有项目',


  tabs: {
    HEADER: "页眉",
    HEADER_TABLE: "页眉表格",
    TASK: "任务",
    SIGN_OFF: "签署",
    SETTINGS: "设置",
    PREVIEW: "预览"
  },
  Details: '细节',
  Bookmark: '书签',
  Editable: '可编辑的',
  Preview: '预览',
  TitleOptional: '标题(可选)',
  HideonPDF: '在PDF中隐藏',
  DescriptionofTask: '任务描述',
  NumberNo: '编号',
  EPCContractor: 'EPC 承包商',
  OQCompany: 'OQ 公司',
  JobTitle: '职位名称',
  AddDigitalDocumentfor: '添加数字文档',
  EditDigitalDocumentfor: '编辑数字文档',
  ITRDocument: '检查测试记录表文件',
  Partofthe: '签署流程是作为数字文档的一部分进行配置的',
  PunchListItemAttachments: '尾项清单附件',
  MCCAttachments: '机械完工证书附件',
  ProcedureAttachments: '程序附件',
  MOCAttachments: '变更附件',
  FileReadError: '文件读取错误',
  ConsecutiveEmptyRows: '已超过{count}行连续空行，停止检查后续数据。',
  RequiredErrorSection: '必填错误部分',
  Couldnotprocessimport: '由于以下原因，无法处理导入:',
  DuplicateErrorSection: '重复错误部分:',
  ImportFileRow: '导入文件 第 {row} 行',
  RaiseMcc: '提升机械完工移交证书',

  ImportFileLabel: '导入文件',
  NameValueLabel: '名称值',
  DuplicatedText: '重复',
  RowText: '行',
  AndConnector: '和',
  MOCTypeName: '变更类型名称',

  BeginRaisedDate: '提出开始时间',
  EndRaisedDate: '提出结束时间',
  BeginCreatedDate: '开始创建日期',
  EndCreatedDate: '结束创建日期',

  CommentsActions: '评论 / 操作',

  EmptyRowsErrorSection: '空行错误部分',

  RepetitionADD: '重复添加：',
  AddResults: '添加结果',
  Items: '条',
  SavedList: '已添加：',
  YouDoNotHavePermissionToImport: '您当前没有操作此按钮的权限',
  itrDescription: '检查测试表描述',

  NoCCCSKYLINEDataAvailable: '没有可用试运完工证书天际线图数据',
  NoMCCSKYLINEDataAvailable: '没有可用机械完工证书天际线图数据',

  Goto: '跳至',

  // 10-20
  TagQPack: '编号设备单体Q包',
  pwlDescription: '维保描述',

  ActionParty: '执行方',
  ActionPartyName: '执行方名称',

  ActionsTaken: '采取措施',
  AddComments: '添加评论',
  TotalClosed: '关闭条数',


  CreateNewDetailtedReort: '创建新的详细报告',
  CreateNewSummaryReport: '创建新的摘要报告',


  OperationReadinessAssurance: '运行准备与保障',
  OperationsReadiness: '运行准备',
  TechnicalIntegritySafetyReadiness: '技术完整性与安全准备',
  ReliabilityMaintenanceReadiness: '可靠性与维护准备',
  InformationManagementReadiness: '信息管理准备',
  HSSEReadiness: 'HSSE 准备',
  SupplyChainReadinessLogistics: '供应链与物流准备',
  ResponsibleParty: '责任方',
  Categorization: '分类',
  ResponsibleDepartment: '责任部门',
  ReferenceDocumentsTitle: '参考文件标题',
  DocumentReferenceNumber : '文件参考号',
  RevisionNumber: '修订号',
  ActionPlannedStartDate: '行动计划开始时间',
  ActionCompletionDate: '行动完成日期',


  SubSystemDescription: '子系统描述',
  TaggedItemDescription: '标记项目描述',
  AccetpedBy: '验收人',

  SubSystemDescription: '子系统描述',

  OPERATIONREADINESSASSURANCE: '运行准备与保障',
  NoOPERATIONREADINESSASSURANCEDataAvailable:  '没有运行准备与保障数据',
  ContactUs: '联系我们',

  UserManual: '用户手册',
  UserGuide: '用户指南',
  VideoTutorial: '视频教程',

  SelectReportType: '选择报告类型',
  SelectGroupsPDFOnly: '选择组(仅PDF格式)',
  Group: '分组',
  GropDescription: '分组描述',
  LabelonReport: '报告上的标签',
  SeparateGroupingPage: '单独分组页面',
  ConfigureGroupingPagePDFOnly: '配置分组页面 (仅PDF格式)',
  AddRow: '添加行',
  Row: '行',
  RemoveRow: '删除行',
  Text: '文本',
  HasInputSpace: '有输入空间',
  Remove: '删除',
  AddCloumn: '添加列',
  SelectDetails: '选择详细信息',
  ReportCode: '报告编码',
  ReportName: '报告名称',
  ReportCategory: '报告类别',
  ColumnName: '列名',
  HeaderonReport: '报告标题',
  TitleAboveHeader: '标题上方',
  PDFWidth: 'PDF 宽度',
  XLSXWidth: 'XLSX 宽度',
  SaveReport: '保存报告',
  Breakdown: '故障',
  PleaseEnterComment: '请输入评论',
  NotificationPreferences: '通知设置',
  NotificationType:'通知类型',
  NotificationMethod: '通知方式',
  PreferredSearchType: '首选搜索类型',
  Theme:'主题',
  ORAPriority: 'ORA 优先级',

  TableName: "表名称",
  WillPreventHandover: "将阻止移交",
  ProcedureSkeletonStepNumber: "编号",
  PlannedCompletion: "计划完成",
  ActualProgress: "实际进度",
  Pleaseselectapieceofdatatoedit: "请选择一条数据进行编辑",
  ProjectReadinessWorkingStreams: "项目准备工作组",
  ActivityDescription: "活动描述",
  Backlog: "积压",
  OperationReadinessStream: "运营准备流程",

  PleaseSelectReportType: "请选择报告类型",
  PleaseInputReportCode: "请输入报告编码",
  PleaseInputReportName: "请输入报告名称",
  PleaseSelectAtLeastOneColumn: "请至少选择一列",
  CustomReportList: "自定义报告列表",
  FiletersCustomReport: "筛选自定义报告",
  Thereisnocustomreportinthedetails: "详细中没有自定义报告",
  SelectReportOptions: "选择报告选项",
  NoReportSelected: "未选择报告",
  ExportSuccess: "导出成功",
  ExportFailed: "导出失败",

  UploadingPleaseWait:'正在上传中。。。请等待',

  Cannotdeletetagitr: "无法删除编号设备单体ITR(s).因为它们与punchListItem项目相关联,受影响的编号设备单体ITR(s)：",

  Planned: "计划",
  SelectAll: "全部选择",
  RejectAll: "拒绝所有",
  RejectItem: "拒绝单条",
  PLIs: "尾项",
  Attach: "附件",
  AttachCurrentassociateditems: "当前已关联项目",
  AttachTotal: "条",
  AttachSelectfile: "选择文件（可多选上传）",
  AttachSize: "当前选中的文件将自动关联到全部 {count} 项。支持 PDF 格式，单个文件大小不超过 20MB。",
  OtherDocument: "其他文档",
  ReviewAsBuiltDrawings: "审核竣工图纸",
  MOCDisciplines: "变更专业",
  MOCTaggedItems: "变更编号资产",
  MOCSystems: "变更系统",
  MOCSubSystems: "变更子系统",
  MOCAreas: "变更区域",
  MOCModules: "变更模块",
  MOCWorkPacks: "变更工作包",
  MOCJobCards: "变更工作卡",
  RequiresClarification: "需要澄清",
  NCRToBeIssued: "待发布",
  MOCDrawings: "变更图纸",
  ResonsibleDepartment: "责任部门",

  TagITRsEditDocument: "编辑已编号检查测试表文档",
  Detail: "明细",
  TaskProgress: "任务进度",
  Tasks: "任务",
  ShowAllTasks: "展开所有任务",
  CollapseAllTasks: "收起所有任务",
  NoDigltalDocumentAvallable: "没有可用的电子文档",
  AddPunchListItem: "添加尾项",
  TagAttachments: "其他设备附件",
  DrawingAttachments: "图纸附件",
  PreservationWorkList: "维护保养",
  PreservationDetail: "保养内容",
  PreservationInterval: "保养间隔",
  Thereareitemsthathavenotbeenraisedyet: "有 {count} 项未提升，仅可删除已提升的项",
  Areyousureyouwanttodeleteselecteditems: "确定要删除选中的 {count} 项吗？",
  Not: "未",
  Documentcannotbegeneratedasthereisnotemplate: "由于没有模板，无法生成文档",
  Overdue: "逾期",
  MCC_COMPLETED: "机械完工证书 已完成",
  MCC_PENDING: "机械完工证书 待处理",
  MCC_OVERDUE: "机械完工证书 已逾期",
  CCC_COMPLETED: "试运完工证书 已完成",
  CCC_PENDING: "试运完工证书 待处理",
  CCC_OVERDUE: "试运完工证书 已逾期",
  Noss: "无" ,
  AddAuthorisedPersonProfession: "添加授权人员专业",
  AddAuthorisedPersonDiscipline: "添加授权人员学科",
  CCCAttachments: "试运完工证书附件",
  Fulls: "完整",
  Documentation: "文档",
  Dossier: "文档",
  AddAuthorisedPersonSubcontractorName: "添加授权人员分包商名称",
  TaggedItemsDescription: "编号资产描述",
  Doyouneedtosavethecurrentstateandaddapunch: "你需要保存当前状态并加入一个尾项吗？",
  TagPWLTaggedItem: "维护保养清单编号资产",
  TaggedItemLocation: "编号资产位置",
  TagPWLFrequency: "维护保养清单频率",
  HandoverCertificate: "证书",
  CloseItems: "关闭项目",
  SignOffDate: "签署日期",
  TypeinaDocumentCode: "输入文档编号",
  RecentCodes: "近期编码",
  Code: "编码",
  DocumentName: "文件名称",
  Uploadfiles: "上传文件",
  SelectEntityType: "选择实体类型",
  Searchcriteriacleared: "搜索条件已清除",
  Emailsentsuccessfullyto: "邮件已成功发送至",
  Usercreatedsuccessfully: "用户创建成功，但邮箱发送失败",
  Dear: "亲爱的",
  Pleaseselectaprojectfirst: "请先选择项目",
  days: "天",
  TagPWLAttachments: "维护保养清单附件",
  Ongoing: "进行中",
  FilterConfiguration: "过滤器配置",
  SelectFilterConditions: "选择过滤条件",
  PleaseSelectReportFirst: "请先选择报告",
  ScheduledReportHistoryList: "计划报表历史列表",
  GenerationTime: "生成时间",
  FileSize: "文件大小",
  Success: "成功",
  Failed: "失败",
  NoFilterConfigured: "未配置过滤条件",
  RelatedTagPWLs: "相关维护保养清单",
  SearchFor: "查找",
  NoEmailConfigured: "未配置邮箱，无法发送通知",
  Emailsendingfailed: "邮件发送失败",
  NoRecipientEmail: "分配的用户没有邮箱",
  WorkPageAttachments: "工作包附件",
  JobCardAttachments: "工作卡附件",
  RoundApprovals: "循环审批",
  WorkPackTypeDocument: "工作包类型文档",
  UploadJSONDocument: "上传 JSON 文档",
  WorkPackTypeCoverSheet: "工作包类型封面",
  CreateCoverSheet: "创建封面",
  NoData: "没有数据",
}
